import { STATIC_BLOG_TOOLS_SIDEBAR_HTML } from '../content/staticBlogToolsSidebarHtml';

function StaticBlogToolsSidebar() {
  return <div dangerouslySetInnerHTML={{ __html: STATIC_BLOG_TOOLS_SIDEBAR_HTML }} />;
}

export default StaticBlogToolsSidebar;
